import { render, staticRenderFns } from "./ModalCategoria.vue?vue&type=template&id=303848f4&"
import script from "./ModalCategoria.vue?vue&type=script&lang=js&"
export * from "./ModalCategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports